import Field from "@/components/Field";
import { NumberInput } from "@/components/ui/NumberInput";
import { useTranslation } from "react-i18next";
import { usePayrollVisitCountHoursCalculation } from "../hooks/usePayrollVisitCountHoursCalculation";

interface PayrollVisitCountCorrectedFieldProps {
  hoursBoundToVisits?: boolean | null;
  mostFrequentPlannedVisitDuration?: string | null;
}

export default function PayrollVisitCountCorrectedField({
  hoursBoundToVisits,
  mostFrequentPlannedVisitDuration,
}: PayrollVisitCountCorrectedFieldProps) {
  const { t } = useTranslation();

  usePayrollVisitCountHoursCalculation({
    visitCountPath: "visit_count_corrected",
    hoursPath: "hours_worked_corrected",
    hoursBoundToVisits,
    mostFrequentPlannedVisitDuration,
  });

  return (
    <Field
      name="visit_count_corrected"
      label={t("payrolls.fields.visit_count_corrected")}
      render={({ field }) => <NumberInput {...field} />}
    />
  );
}
